import React from 'react';

const Tipping = (props) => (
    <svg
        width="22px"
        height="22px"
        viewBox="0 0 22 22"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...props}
    >
        <title>Icon/Tip b@1.5x</title>
        <g id="Gscope---Left-Navigation" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Gscope_icons" transform="translate(-387.000000, -1533.000000)" fill="#000000">
                <g id="Icon/Tip-b" transform="translate(387.000000, 1533.000000)">
                    <path
                        d="M11,0.5 C16.7989899,0.5 21.5,5.20101013 21.5,11 C21.5,16.7989899 16.7989899,21.5 11,21.5 C5.20101013,21.5 0.5,16.7989899 0.5,11 C0.5,5.20101013 5.20101013,0.5 11,0.5 Z M11,2 C6.02943725,2 2,6.02943725 2,11 C2,15.9705627 6.02943725,20 11,20 C15.9705627,20 20,15.9705627 20,11 C20,6.02943725 15.9705627,2 11,2 Z M11,15.5 C11.4142136,15.5 11.75,15.8357864 11.75,16.25 C11.75,16.6642136 11.4142136,17 11,17 C10.5857864,17 10.25,16.6642136 10.25,16.25 C10.25,15.8357864 10.5857864,15.5 11,15.5 Z M11,5 C11.3796958,5 11.693491,5.28215388 11.7431534,5.64822944 L11.75,5.75 L11.75,13.46105 C11.75,13.8752636 11.4142136,14.21105 11,14.21105 C10.6203042,14.21105 10.306509,13.9288961 10.2568466,13.5628206 L10.25,13.46105 L10.25,5.75 C10.25,5.33578644 10.5857864,5 11,5 Z"
                        id="🎨-Color"
                    ></path>
                </g>
            </g>
        </g>
    </svg>
);

export default Tipping;
